import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';

import mainTpl from './templates/main.html';


@Module({
    name: 'app.admin.company.hauler',
    modules: [
        BaseRoute,
    ],
})
@State({
    name: 'r.in.top.admin.company.hauler',
    url: '/hauler',
    template: mainTpl,
    ncyBreadcrumb: {
        label: 'Hauler & Applicator',
    },
})
export default class States { }



// WEBPACK FOOTER //
// ./src/app/admin/hauler/routing.js